export default __webpack_public_path__ + "static/media/Salesforce.91433abe.svg";